/**
 * Locks scrolling on the document root (`<html>`) while active.
 * Uses reference counting so nested callers (e.g. modal + lightbox) only
 * restore the previous `overflow` after the final `release()`.
 */
let lockDepth = 0
let savedOverflow = ''

export function lockDocumentScroll(): () => void {
  if (typeof document === 'undefined') {
    return () => {}
  }

  if (lockDepth === 0) {
    savedOverflow = document.documentElement.style.overflow
    document.documentElement.style.overflow = 'hidden'
  }
  lockDepth += 1

  let released = false
  return () => {
    if (released || typeof document === 'undefined') {
      return
    }
    released = true
    lockDepth -= 1
    if (lockDepth === 0) {
      document.documentElement.style.overflow = savedOverflow
    }
  }
}
